import { IAttrValue, IRowData } from "@multiweb/types/contracts";
import { OWDate } from "../../Global/Base/DataTypes/OWDate";
import { Enum } from "./DataTypes/Enums";
import { IVariant } from "./DataTypes/IVariant";

const knownTypes = [Date, OWDate, Enum, IVariant];

/**
 * Pomocná třída usnadňující čtení koncové hodnoty atributu
 * @includeToDoc
 */
export class AttrValueReader {
    /**
     * Načte koncovou hodnotu aplikačního atributu
     * @param attrValue Struktura s daty konkrétního aplikačního atributu
     * @param explicitKnownTypes Pole známých datových typů. Pokud je hodnota instancí tohoto typu, vrací se hodnota tohoto typu.
     * @returns Vrací koncovou hodnotu atributu
     */
    public static read(attrValue: IAttrValue | object | null | undefined, explicitKnownTypes: any[] = []): any {
        if (attrValue == null)
            return null;

        if (knownTypes.some(t => attrValue instanceof t) || (explicitKnownTypes && explicitKnownTypes.some(t => attrValue instanceof t)))
            return attrValue;

        return attrValue.valueOf();
    }

    /**
     * Načte z řádku koncovou hodnotu aplikačního atributu
     * @param row Celý řádek s hodnotami aplikačních záznamů
     * @param attrName Název atributu, pro nějž se má číst hodnota
     * @param explicitKnownTypes Pole známých datových typů. Pokud je hodnota instancí tohoto typu, vrací se hodnota tohoto typu.
     * @returns Vrací koncovou hodnotu atributu
     */
    public static readRow(row: IRowData, attrName: string, explicitKnownTypes: any[] = []): any {
        return AttrValueReader.read(row[attrName], explicitKnownTypes);
    }
}
